import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { DecisionFacade } from '@applyboard/feature-decision';
import { isIdentityAvailable, getUserId, getUserType, identifyUser } from "../utils/identity";
import Queue from "../Queue";
var queue = new Queue('ab_events-buffer-for-featuredecisions');
export var FeatureDecisionsClient = /*#__PURE__*/function () {
  function FeatureDecisionsClient() {
    _classCallCheck(this, FeatureDecisionsClient);
  }
  _createClass(FeatureDecisionsClient, null, [{
    key: "getInstance",
    value: function getInstance() {
      var _this = this;
      if (!this.decisionEngineInstance && window.OPTIMIZELY_KEY) {
        // setLogLevel(window.OPTIMIZELY_LOGGING_LEVEL);

        var decisionFacade = new DecisionFacade();
        decisionFacade.optimizelyDecisionFactory({
          logger: console,
          sdkKey: window.OPTIMIZELY_KEY,
          logLevel: window.OPTIMIZELY_LOGGING_LEVEL === 'error' ? 4 : 3
        }).then(function (decisionFactory) {
          if (!_this.isReady) {
            _this.decisionEngineInstance = decisionFactory.createDecision(getUserId(), {
              role: getUserType()
            });
            _this.isReady = true;
          }
        });
      }
      return this.decisionEngineInstance;
    }
  }, {
    key: "isClientReady",
    value: function isClientReady() {
      return this.isReady;
    }
  }, {
    key: "track",
    value: function track(event) {
      var data = buildMetadata(event.data);
      var engine = this.getInstance();
      if (engine) {
        //@ts-expect-error ToDo: fix this
        engine.trackEvent(event.feature_event_key, data);
      }
    }
  }]);
  return FeatureDecisionsClient;
}();
function buildMetadata(data) {
  if (!data) {
    //@ts-expect-error ToDo: fix this
    return null;
  }
  var tags = {};

  // If we the types are allowed we add it to the tags object.
  for (var _key in data) {
    if (data[_key] === null) {
      tags[_key] = null;
    } else {
      switch (_typeof(data[_key])) {
        case 'string':
          tags[_key] = data[_key];
          break;
        case 'number':
          tags[_key] = data[_key];
          break;
        default:
          break;
      }
    }
  }
  return tags;
}
function sendEventsFromLocalstorage() {
  if (queue.size() > 0) {
    // Dispatch one event at a time (from localstorage)
    for (var index = 0; index < queue.size(); index++) {
      var event = queue.dequeue();
      FeatureDecisionsClient.track(event);
    }
  }
}
export var sendDecisionEvent = function sendDecisionEvent(event) {
  // First, identify user
  identifyUser();
  if (isIdentityAvailable() && FeatureDecisionsClient.getInstance()) {
    // Second, check if there any events in localstorage and send them first
    sendEventsFromLocalstorage();
    // Finally, send the latest created event
    FeatureDecisionsClient.track(event);
  } else {
    // Temporary store event in localstorage (until the identity is set and FeatureDecisions engine SDK become available)
    queue.enqueue(event);
  }
};